import "./App.css";
import React from "react";

const drum_kit = [
  {
    asc_code: 81,
    keyTrigger: "Q",
    id: "Heater-1",
    url: "https://s3.amazonaws.com/freecodecamp/drums/Heater-1.mp3",
  },
  {
    asc_code: 87,
    keyTrigger: "W",
    id: "Heater-2",
    url: "https://s3.amazonaws.com/freecodecamp/drums/Heater-2.mp3",
  },
  {
    asc_code: 69,
    keyTrigger: "E",
    id: "Heater-3",
    url: "https://s3.amazonaws.com/freecodecamp/drums/Heater-3.mp3",
  },
  {
    asc_code: 65,
    keyTrigger: "A",
    id: "Heater-4",
    url: "https://s3.amazonaws.com/freecodecamp/drums/Heater-4_1.mp3",
  },
  {
    asc_code: 83,
    keyTrigger: "S",
    id: "Heater-6",
    url: "https://s3.amazonaws.com/freecodecamp/drums/Heater-6.mp3",
  },
  {
    asc_code: 68,
    keyTrigger: "D",
    id: "Brk Snare",
    url: "https://s3.amazonaws.com/freecodecamp/drums/Brk_Snr.mp3",
  },
  {
    asc_code: 90,
    keyTrigger: "Z",
    id: "Kick n Hat",
    url: "https://s3.amazonaws.com/freecodecamp/drums/Kick_n_Hat.mp3",
  },
  {
    asc_code: 88,
    keyTrigger: "X",
    id: "Kick-1",
    url: "https://s3.amazonaws.com/freecodecamp/drums/RP4_KICK_1.mp3",
  },
  {
    asc_code: 67,
    keyTrigger: "C",
    id: "Punchy Kick",
    url: "https://s3.amazonaws.com/freecodecamp/drums/punchy_kick_1.mp3",
  },
];

const inactive = {
  backgroundColor: "black",
};

const active = {
  backgroundColor: "red",
  "box-shadow": "0 0 3rem orange",
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPadButtons: drum_kit,
      currentPadButtonsId: "Drum Kit",
      display: "",
    };

    this.displayName = this.displayName.bind(this);
    this.removeDisplayName = this.removeDisplayName.bind(this);
  }

  removeDisplayName() {
    this.setState({
      display: "",
    });
  }

  displayName(name) {
    this.setState({
      display: name,
    });
    setTimeout(() => this.removeDisplayName(), 2000);
  }

  render() {
    return (
      <div className="inner-container" id="drum-machine">
        <PadButtons
          currentPadButtons={this.state.currentPadButtons}
          display={this.state.display}
          changeDisplay={this.displayName}
        />
        <p id="display">{this.state.display}</p>
      </div>
    );
  }
}

class Drumpad extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pad: inactive,
    };

    this.playSound = this.playSound.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.changePad = this.changePad.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyPress);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyPress);
  }

  handleKeyPress(event) {
    if (event.keyCode === this.props.asc_code) {
      this.playSound();
    }
  }

  changePad() {
    if (this.state.pad.backgroundColor === "black") {
      this.setState({
        pad: active,
      });
    } else {
      this.setState({
        pad: inactive,
      });
    }
  }

  playSound() {
    const sound = document.getElementById(this.props.keyTrigger);
    sound.currentTime = 0;
    sound.play();
    this.changePad();
    setTimeout(() => this.changePad(), 100);
    this.props.changeDisplay(this.props.id);
  }

  render() {
    return (
      <div
        className="drum-pad"
        id={this.props.id}
        onClick={this.playSound}
        style={this.state.pad}
      >
        <audio
          className="clip"
          src={this.props.clip}
          id={this.props.keyTrigger}
        />
        {this.props.keyTrigger}
      </div>
    );
  }
}

class PadButtons extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    let padButtons = this.props.currentPadButtons.map(
      (button, i, padButtonsArr) => {
        return (
          <div>
            <Drumpad
              clip={padButtonsArr[i].url}
              id={padButtonsArr[i].id}
              asc_code={padButtonsArr[i].asc_code}
              keyTrigger={padButtonsArr[i].keyTrigger}
              display={this.props.display}
              changeDisplay={this.props.changeDisplay}
            />
          </div>
        );
      }
    );
    return <div className="pad-buttons">{padButtons}</div>;
  }
}

export default App;
